#import "../fragments/sales-automation-stageset.graphql"

mutation CreateClosedLeadTaskTemplate($taskTemplate: CreateClosedLeadTaskTemplateInputFieldInput!) {
    createClosedLeadTaskTemplate(input: {taskTemplate: $taskTemplate}) {
        stageset {
            ...SalesAutomationStageset
        }
    }
}
